import React from 'react';
import CardSimple from 'screens/components/basic/CardSimple';

const General = () => {
    return(
        <div id="new-version">
            <br />
            <div>
                <CardSimple>
                    <div className="support-wrapper support-manual">
                        <h2>Unable to see a new version</h2>
                        <p>If a new version was released and you are not able to see it, maybe the browser is reading a
                            cached version of TechPOS. To fix this problem:
                        </p>
                        <ul>
                            <li>In your browser press Ctrl + Shift + Delete, you should see the following screen:</li>
                            <img src="http://techpos.ca/support-images/Troubleshoot/General/general1.PNG" />
                            <li>Click on Advance</li>
                            <img src="http://techpos.ca/support-images/Troubleshoot/General/general2.PNG" />
                            <li>Make sure Browsing History, Download history and Cached images and files are selected</li>
                            <li>Click on Clear Data</li>
                            <li>Refresh TechPOS</li>
                        </ul>
                    </div>
                </CardSimple>
            </div>
        </div>
    )
}

export default General;